import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { courseFeatures } from '../mockData';

const CourseSection = () => {
  return (
    <section id="curso" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-golden/10 text-golden text-sm font-medium tracking-wider rounded-full mb-4">
            CURSO ONLINE
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-charcoal mb-6">
            Transformación Financiera
          </h2>
          <p className="text-lg text-charcoal/70 max-w-3xl mx-auto leading-relaxed">
            Un programa completo para que cambies tu relación con el dinero, 
            organices tus finanzas y logres la libertad financiera que mereces.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/e1a20952-b31c-4be9-b1e6-00ce412710a7/images/a9f4051491a513ef75d61f2ff89852d6624b436d58d57bef4bcd9b902b50e504.png"
                alt="Curso de Finanzas Personales - Consultoría Financiera"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-lilac/20 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Features */}
          <div className="space-y-6">
            <h3 className="text-2xl font-serif text-charcoal mb-8">
              Lo que aprenderás:
            </h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {courseFeatures.map((feature) => (
                <Card key={feature.id} className="p-6 border-cream-dark hover:shadow-lg transition-shadow duration-300">
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-golden/10 flex items-center justify-center mt-1">
                      <Check className="text-golden" size={16} />
                    </div>
                    <div>
                      <h4 className="font-medium text-charcoal mb-2">{feature.title}</h4>
                      <p className="text-sm text-charcoal/60">{feature.description}</p>
                    </div>
                  </div>
                </Card>
              ))}
            </div>

            <div className="pt-8">
              <Button 
                onClick={() => window.open('https://hotmart.com/es/club/transformacion-financiera-t', '_blank')}
                className="bg-golden hover:bg-golden-dark text-white px-8 py-6 text-base font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto"
              >
                Inscríbete Ahora
                <ArrowRight className="ml-2" size={20} />
              </Button>
              <p className="text-sm text-charcoal/60 mt-4">
                ⭐ Acceso inmediato • Material descargable • Soporte personalizado
              </p>
            </div>
          </div>
        </div>

        {/* Testimonial Banner */}
        <div className="bg-gradient-to-r from-cream via-lilac-light to-cream rounded-2xl p-8 sm:p-12 text-center">
          <p className="text-xl sm:text-2xl font-serif text-charcoal mb-4 italic">
            "Este curso cambió mi vida. Pasé de tener deudas abrumadoras a tener ahorros y paz mental."
          </p>
          <p className="text-charcoal/70 font-medium">
            — María G., Egresada del Curso
          </p>
        </div>
      </div>
    </section>
  );
};

export default CourseSection;
